import * as React from "react";
import LabelCtl from "./LabelCtl";
import ExchangeItemCtl from "./ExchangeItemCtl";
import { ListItem } from "@testout/testout-commerce/models/ListItem";
import { PriceList } from "@testout/testout-commerce/models/commerce/PriceList";
import { SalesItem } from "@testout/testout-commerce/models/commerce/SalesItem";
import "./ModalCtl.scss";

interface IModalProps {
    headerText: string;
    description: string;
    submitButton: string;
    saveInProgress: boolean;
    originalItems?: SalesItem[];
    exchangeProductNumbers?: string[];
    onCancel: () => void;
    onSubmit: () => void;
    onChange?: (productNumber: string, index: number) => void;
    priceList?: PriceList;
}

interface IModalState {
    hasChanged: boolean;
}

export default class ModalCtl extends React.PureComponent<IModalProps, IModalState> {
    constructor(props: IModalProps) {
        super(props);
        this.state = { hasChanged: false };
    }

    onExchangeItemChange = (productNumber: string, index: number) => {
        if (this.props.onChange !== undefined) {
            this.props.onChange(productNumber, index);
            this.setState({ hasChanged: true });
        }
    }

    getExchangeList = (item: SalesItem): ListItem[] => {
        let t = this.props.priceList?.prices.filter(price => item.unitPrice === price.unitPrice || item.overridePricing).map(price => {
            return { name: price.product?.title || "", value: price.productNumber.toString() };
        }) ?? new Array<ListItem>();
        return t;
    }

    getExchangeProductNumber = (i: number): string => {
        if (this.props.exchangeProductNumbers === undefined)
            return "";
        return this.props.exchangeProductNumbers[i];
    }

    render() {
        return <div className="modalScreenBackground">
                   <div className="modalDialog">
                       <div className="modalHeader">
                           <LabelCtl className="modalHeaderTitle" label={this.props.headerText}/>
                           <button className="link" onClick={() => this.props.onCancel()}>
                               <div className="modalCloseButton">
                                   <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                       <path d="M14.5,1.5l-13,13m0-13,13,13" transform="translate(-1 -1)" stroke="#ffffff" strokeWidth="3"/>
                                   </svg>
                               </div>
                           </button>
                       </div>
                       {this.props.saveInProgress && <div className="inProgress"><div className="spinner"></div></div>}
                       <p>{this.props.description}</p>
                       {this.props.submitButton === "Exchange" && this.props.originalItems?.map((item: SalesItem, i) =>
                           <ExchangeItemCtl quantity={item.quantity} title={this.props.priceList?.products?.find(p => p.productNumber === item.productNumber.toString())?.title ?? ""}
                                            exchangeProductNumber={this.getExchangeProductNumber(i)} index={i} 
                                            exchangeList={this.getExchangeList(item)} onChange={this.onExchangeItemChange} />
                       )}
                       <div className="modalBottomButtons">
                           <button className="secondary" onClick={() => this.props.onCancel()}>Cancel</button>
                           <button className="primary" onClick={() => this.props.onSubmit()} 
                                   disabled={this.props.saveInProgress || (this.props.submitButton === "Exchange" && !this.state.hasChanged)}>
                               {this.props.submitButton}
                           </button>
                       </div>
                   </div>
               </div>;
    }
}
